import { useContext, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ServiceContext } from "../../../contexts/ServiceContext";
import { ReactComponent as DescriptionIcon } from "../../../icons/description-settings.svg";
import { ReactComponent as WebsiteIcon } from "../../../icons/website-settings.svg";
import { ReactComponent as EmailIcon } from "../../../icons/email-settings.svg";
import { AppAlert } from "../../../utils/AppAlert";
import { ApiError } from "../../../services/ApiError";
import "./company.css";

function Company() {
  const { infrastructureService } = useContext(ServiceContext);
  const [loading, setLoading] = useState(true);
  const [loadingSave, setLoadingSave] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [webSite, setWebSite] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSuspended, setIsSuspended] = useState(false);

  const { id } = useParams();

  const navigate = useNavigate();

function validateCompany({ name, email }) {
  if (!name || name.trim() === "") {
    setErrorMessage("Name is required");
    return false;
  }
  if (!email || email.trim() === "") {
    setErrorMessage("Email is required");
    return false;
  }
  return true;
}

  async function handleSaveClick() {
    if(id === "new"){
      let addCompany = {
        name: name,
        email: email,
        webSite: webSite,
        isSuspended: Boolean(isSuspended)
      };
      try {
        setLoadingSave(true);
        if (!validateCompany(addCompany)) return; 
        await infrastructureService.put("Company", addCompany);
        setErrorMessage("");
        navigate(-1);
        AppAlert.success("The company was added successfully");
      } catch (err) {
         if (err instanceof ApiError) {
            if (err.errors) {
              setErrorMessage(Object.values(err.errors).flat().join("\n"));
            } else {
              setErrorMessage(err.message);
            }
          } else {
            setErrorMessage(err.message || "Unexpected error");
          }
      }
      finally{
        setLoadingSave(false);
      }
    }else{
      let editCompany = {
        id: id,
        name: name,
        email: email,
        webSite: webSite,
        isSuspended: Boolean(isSuspended)
      };
      try {
        setLoadingSave(true); 
        if (!validateCompany(editCompany)) return; 
        await infrastructureService.patch("Company", editCompany);
        navigate(-1);
        AppAlert.success("Success! Changes have been applied.");
      } catch (err) {
         if (err instanceof ApiError) {
            if (err.errors) {
              setErrorMessage(Object.values(err.errors).flat().join("\n"));
            } else {
              setErrorMessage(err.message);
            }
          } else {
            setErrorMessage(err.message || "Unexpected error");
          }
      }
      finally{
        setLoadingSave(false);
      }
    }
  }

  function handleCancelClick() {
    navigate(-1);
  }

  useEffect(() => {
     if(id !== "new"){
       const fetchCompanies = async () => {
        let company = {
          companyId: id
        };
        try {
           const data = await infrastructureService.get("Company", company); 
           setEmail(data.email);
           setName(data.name);
           setWebSite(data.webSite);
           setIsSuspended(Boolean(data.isSuspended));
        } catch (error) {
           console.error("Error fetching company:", error);
        } finally {
          setLoading(false);
        }
     };

     fetchCompanies();
    }else{
       setLoading(false);
    }
  }, [infrastructureService, id]);

  if (loading) return <div>Loading...</div>;

  return (    
       <div className="company-settings">
        <div className="container">
          <div className="card">
            <div className="text">Company Settings</div>
          </div>
          <div className="inputs">
            <div className="input">
              <DescriptionIcon/>
              <input placeholder="Name" onChange={(e) => setName(e.target.value)} value={name}/>
            </div>
            <div className="input">
              <EmailIcon/>
              <input type="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} value={email}/>
            </div>
            <div className="input">
              <WebsiteIcon/>
              <input placeholder="WebSite" onChange={(e) => setWebSite(e.target.value)} value={webSite}/>
           </div>
           <div className='input settings-checkbox-c'>
               <div className="checkbox-c">
                  <label className="toggle-switch">
                     <input className="toggle-input" id="toggle" type="checkbox" onChange={(e) => setIsSuspended(e.target.checked)} checked={isSuspended}/>
                     <label className="toggle-label" htmlFor="toggle"></label>
                     <span className="toggle-label-text">Is suspended</span>
                  </label> 
                </div>      
             </div>
           {errorMessage && (
            <div className="error input">
              <span style={{paddingLeft: "10px"}}>{errorMessage}</span>
            </div>
           )}
           <div className="submit-container">
            <div className="cancel" onClick={handleCancelClick}>Cancel</div>
            {!loadingSave && (<div className="submit" onClick={handleSaveClick}>Save</div>)}
            {loadingSave && (<div className="submit">Loading...</div>)}
           </div>
        </div>
      </div>
    </div>
  );
}

export default Company;